<template>
  <div class="all">
    <div class="nav-pc">
      <div class="title">
        <img src="@/static/img/xlhd_edge_icon.svg" />
        活动详情
      </div>
    </div>
    <div class="center-pc">
        <p class="p-item">
            <label class="label-item"><span>名称</span>{{ activityData.title }}</label>
            <label class="label-item"><span>地点</span>{{ activityData.address }}</label>
            <label class="label-item"><span>活动规模</span>{{ activityData.activityScale }}人</label>
        </p>
        <p class="p-item">
            <label class="label-item"><span>活动费用</span>{{ $cookies.get("regType") == 2 ? activityData.activityCost1 : activityData.activityCost2 }}</label>
            <label class="label-item"><span>活动主持人</span>{{ activityData.activityHost }}</label>
        </p>
        <p class="p-item">
            <label class="label-item"><span>嘉宾</span>{{ activityData.activityGuest }}</label>
        </p>
        <p class="p-item">
            <label class="label-item"><span>活动时间</span>{{ activityData.startTime | timeFilter }} -- {{ activityData.endTime | timeFilter }}</label>
        </p>
        <p class="p-item">
            <label class="label-item"><span>主办单位</span>{{ activityData.activityOrganizer }}</label>
        </p>
        <img :src="activityData.coverImageId | imgFilter" />
    </div>

    <div class="foo">
      <div>
        <button class="leftBtn" @click="goBack">返回</button>
        <button class="rightBtn" @click="submit">{{ activityData.isEnroll == 1 ? '已报名' : '报名'}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js"
import { invitedGuestEnroll, normalGuestEnroll } from "@/api/series"
var that

export default {
  data() {
    return {
      activityData: {}
    }
  },
  filters: {
      timeFilter: function(tsp) {
          try {
              if (!tsp || tsp.toString().length == 0) {
              return ''
              }

              return that.$parseTime(tsp, '{y}-{m}-{d} {h}:{i}')
          } catch (err) {
              return ''
          }
      },
      imgFilter: function(id) {
          var url = that.$session.get("cmm").browseDomain + '/' + id
        return url
      }
  },
  beforeCreate() {
      that = this
  },
  created() {
    if(!this.$route.params.id) {
      this.$message({
        message: '活动不存在',
        type: 'warning'
      })
      return
    }
    var activityList = sessionData("get", "activityList")
    for(let i=0; i<activityList.length; i++) {
      if(activityList[i].id == this.$route.params.id) {
        this.activityData = activityList[i]
        break
      }
    }
  },
  watch: {

  },
    methods: {
      goBack() {
          this.$router.push({
            name: 'series_act'
        })
      },
      submit() {
        if(this.activityData.isEnroll == 1) {
          return;
        }
        this.$msgbox({
            title: "确认信息",
            message: "确认报名该活动？",
            showClose: false,
            showCancelButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            cancelButtonClass: "cancel-btn-color",
            confirmButtonClass: "btn-color",
            callback: (action, instance) => {
                if (action == "confirm") {
                  if(this.$cookies.get("regType") == 2) {
                    invitedGuestEnroll(this.activityData.id).then(res => {
                      if(res.code == 200) {
                        this.$message({
                          message: '成功报名',
                          type: 'success'
                        })
                        setTimeout(() => {
                          this.goBack()
                        }, 1000);
                      }
                    })
                  } else {
                    // guestId
                    normalGuestEnroll(this.activityData.id).then(res => {
                      if(res.code == 200) {
                        this.$message({
                          message: '成功报名',
                          type: 'success'
                        })
                        setTimeout(() => {
                          this.goBack()
                        }, 1000);
                      }
                    })
                  }
                }
            }
        });
      }
    }
};
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>
<style scoped>
.p-item {
    margin-bottom: 25px;
    font-size: 20px;
    color: #C1A17B;
}
.p-item:nth-child(-n + 2) .label-item {
    width: 33.3%;
    display: inline-block;
}
.p-item span {
    margin-right: 30px;
    font-family: "sourcehans-CN";
}
</style>
